import React, { ChangeEvent, useEffect, useState } from "react";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";
import { GET_FULL_EMPLOYEE_DATA, UPDATE_EMPLOYEE_DATA } from "../../../../config/config";
import { convert12HourFormat } from "../../../../utils/time.date.utlis";
import blankProfile from '../../../../assets/image/blankProfile.webp';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faPen, faSpinner, faTimes } from "@fortawesome/free-solid-svg-icons";

interface EmpDataContextProps {
    user_id : number
}

interface EmployeeDataProps {
  user_id : number;
  first_name: string;
  last_name: string;
  email: string;
  position: string;
  department_name: string;
  current_time_sched : string | null;
  wfh_sched? : string | null;
  onsite_sched? : string | null;
  start_date? :string | null;
  regularization_date? : string | null;
}

const week_days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];

const EmployeeData : React.FC<EmpDataContextProps> = ({user_id}) => {
    const [employee_data, set_Employee_data] = useState<EmployeeDataProps | null>(null);
    const [employee_data_updates, set_Employee_data_updates] = useState<EmployeeDataProps>({} as EmployeeDataProps);
    const [sched_editing, set_sched_editing] = useState<boolean>(false);
    const [updateLoading, setUpdateLoading] = useState<boolean>(false);
    const [date_editing, setDateEditing] = useState<boolean>(false);
    const [dateUpdateLoading, setDateUpdateLoading] = useState<boolean>(false);

    const convertTime = (timeRange : string | null | undefined) => {
        if(!timeRange) return '';
        const [timein, timeout] = timeRange.split("-");
        return `${convert12HourFormat(timein)} - ${convert12HourFormat(timeout)}`;
    }

    const checkDayIncluded = (day_arr : string | null | undefined, day_index : number) => {
        if(!day_arr) return false;
        const arr = JSON.parse(day_arr);
        return arr.includes(day_index);
    }

    const update_sched_arr = (
        event : ChangeEvent<HTMLInputElement>,
        day : string | null | undefined, 
        day_index : number, 
        sched : number
    ) => {
        //sched : 0 = onsite, 1 = wfh
        if(!employee_data_updates) return false;
        const checked = event.currentTarget.checked;
        const days_arr : number[] = day ? JSON.parse(day) : [];
        const updated_days = checked
            ? [...days_arr, day_index]
            : days_arr.filter(num => num !== day_index);
        const sorted_days = updated_days.length > 0
            ? JSON.stringify(updated_days.sort((a, b) => a - b))
            : "";
        set_Employee_data_updates(
            sched === 0
                ? { ...employee_data_updates, onsite_sched: sorted_days }
                : { ...employee_data_updates, wfh_sched: sorted_days }
        );
    }

    const convertDaysArr = (days_arr_str : string | undefined | null) => {
        if(!days_arr_str) return "None"
        const days_arr : number[] = JSON.parse(days_arr_str);
        const day_names = days_arr.map(day_index => week_days[day_index]);
        return day_names.length ? day_names.join(", ") : "None";
    }

    const updateEmployeeData = async(toUpdate : string) => {
        if(!employee_data_updates) return false;
        if(toUpdate === 'shift_sched') setUpdateLoading(true);
        if(toUpdate === 'probi_reg_date') setDateUpdateLoading(true);
        try{
            const filtered_emp_data = {
                ...employee_data_updates,
                onsite_sched: employee_data_updates.onsite_sched ? employee_data_updates.onsite_sched : "",
                wfh_sched: employee_data_updates.wfh_sched ? employee_data_updates.wfh_sched : ""
            }
            await api.post(UPDATE_EMPLOYEE_DATA, filtered_emp_data, {
                headers: { 'Authorization': 'Bearer ' + getToken() }
            });
            set_Employee_data(employee_data_updates);
            if(toUpdate === 'shift_sched') {
                setUpdateLoading(false);
                set_sched_editing(false);
            }
            if(toUpdate === 'probi_reg_date'){
                setDateEditing(false);
                setDateUpdateLoading(false);
            } 
        }catch(e){
            alert('Failed to update data.');
            setUpdateLoading(false);
        }
    }

    useEffect(()=>{
        const getFullEmpData = async() => {
            const data = await api.get(GET_FULL_EMPLOYEE_DATA+user_id, {
                headers: { 'Authorization': 'Bearer ' + getToken() }
            });
            const emp_data = data.data as EmployeeDataProps;
            set_Employee_data(emp_data);
            set_Employee_data_updates(emp_data);
        }
        getFullEmpData();
    },[user_id]);
    
    return(
        <div className="min-w-[52rem]">
            <div className="flex gap-6">
                <div>
                    <div className="flex gap-6">
                        <div>
                            <img src={blankProfile} className='w-32 border' alt="userProfile" />
                        </div>
                        <div>
                            <div>
                                <h2>
                                    {employee_data?.first_name} {employee_data?.last_name}
                                </h2>
                            </div>
                            <div>
                                <h2>
                                    {employee_data?.email}
                                </h2>
                            </div>
                        </div>

                    </div>
                    <div>
                        <h2>
                            {employee_data?.position}
                        </h2>
                    </div>
                    <div>
                        <h2>
                            {employee_data?.department_name}
                        </h2>
                    </div>
                    <div>
                        <h2>
                            {convertTime(employee_data?.current_time_sched)}
                        </h2>
                    </div>
                </div>
                <div className="flex flex-col gap-4">
                    <div>
                        <div>
                            <div className="flex gap-2 items-center">
                                <h2>
                                    Shift schedules
                                </h2>
                                {updateLoading ? (
                                    <div>
                                        <FontAwesomeIcon className="text-blue-400 animate-spin" icon={faSpinner} />
                                    </div>
                                ) : (
                                    <>
                                        {sched_editing ? (
                                            <div className="flex gap-4 items-center">
                                                <button type="button" onClick={()=>updateEmployeeData('shift_sched')} className="text-green-500 text-lg">
                                                    <FontAwesomeIcon icon={faCheck} />
                                                </button>
                                                <button type="button" onClick={()=>set_sched_editing(false)} className="text-red-400">
                                                    <FontAwesomeIcon icon={faTimes} />
                                                </button>
                                            </div>
                                        ):(
                                            <div>
                                                <button type="button" onClick={()=>set_sched_editing(true)} className="text-blue-500">
                                                    <FontAwesomeIcon icon={faPen} />
                                                </button>
                                            </div>
                                        )}                                
                                    </>
                                )}
                            </div>
                            {sched_editing ? (
                                    <div>
                                        <div className="flex gap-2">
                                            <h2>Onsite Schedule:</h2>
                                        </div>
                                        <div className="flex gap-2 items-center">
                                            {week_days.map((day, index) => (
                                                <div className="flex gap-1 items-center">
                                                    <input 
                                                        checked={checkDayIncluded(employee_data_updates?.onsite_sched, index)}
                                                        onChange={(e)=>update_sched_arr(e, employee_data_updates?.onsite_sched, index, 0)} 
                                                        type="checkbox" 
                                                        />
                                                    <p>{day}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ): (
                                    <div>
                                        <div className="flex gap-2">
                                            <h2>Onsite:</h2>
                                        </div>
                                        <div>
                                            <h2>
                                                {convertDaysArr(employee_data?.onsite_sched)}
                                            </h2>
                                        </div>
                                    </div>
                                )}
                        </div>
                        <div>
                            {sched_editing ? (
                                <div>
                                    <div className="flex gap-2">
                                        <h2>WFH:</h2>
                                    </div>
                                    <div className="flex gap-2 items-center">
                                        {week_days.map((day, index) => (
                                            <div className="flex gap-1 items-center">
                                                <input 
                                                    checked={checkDayIncluded(employee_data_updates?.wfh_sched, index)}
                                                    onChange={(e)=>update_sched_arr(e, employee_data_updates?.wfh_sched, index, 1)}
                                                    type="checkbox" 
                                                />
                                                <p>{day}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div className="flex gap-2">
                                        <h2>WFH Schedule:</h2>
                                    </div>
                                    <div>
                                        {convertDaysArr(employee_data?.wfh_sched)}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div>
                        <div>
                            <div className="flex gap-2 items-center">
                                <h2>
                                    Probi / Regularization dates
                                </h2>
                                {dateUpdateLoading ? (
                                    <div>
                                        <FontAwesomeIcon className="text-blue-400 animate-spin" icon={faSpinner} />
                                    </div>
                                ) : (
                                    <>
                                        {date_editing ? (
                                            <div className="flex gap-4 items-center">
                                                <button type="button" onClick={()=>updateEmployeeData('probi_reg_date')} className="text-green-500 text-lg">
                                                    <FontAwesomeIcon icon={faCheck} />
                                                </button>
                                                <button type="button" onClick={()=>setDateEditing(false)} className="text-red-400">
                                                    <FontAwesomeIcon icon={faTimes} />
                                                </button>
                                            </div>
                                        ):(
                                            <div>
                                                <button type="button" onClick={()=>setDateEditing(true)} className="text-blue-500">
                                                    <FontAwesomeIcon icon={faPen} />
                                                </button>
                                            </div>
                                        )}                                
                                    </>
                                )}
                            </div>
                            {date_editing ? (
                                    <div>
                                        <div className="flex gap-2">
                                            <h2>Probitionary:</h2>
                                        </div>
                                        <div className="flex gap-2 items-center">
                                            <input
                                                type="date"
                                                onChange={(e) =>
                                                    set_Employee_data_updates((prev) => ({
                                                    ...(prev ?? {}), 
                                                    start_date: e.target.value,
                                                    }))
                                                }
                                                value={employee_data_updates?.start_date || ""}
                                            />
                                        </div>
                                    </div>
                                ): (
                                    <div>
                                        <div className="flex gap-2">
                                            <h2>Probitionary:</h2>
                                        </div>
                                        <div>
                                            <h2>
                                                {employee_data?.start_date ? employee_data.start_date : 'Not specified'}
                                            </h2>
                                        </div>
                                    </div>
                                )}
                        </div>
                        <div>
                            {date_editing ? (
                                <div>
                                    <div className="flex gap-2">
                                        <h2>Regularization:</h2>
                                    </div>
                                    <div className="flex gap-2 items-center">
                                        <input
                                            type="date"
                                            onChange={(e) =>
                                                set_Employee_data_updates((prev) => ({
                                                ...(prev ?? {}), 
                                                regularization_date: e.target.value,
                                                }))
                                            }
                                            value={employee_data_updates?.regularization_date || ""}
                                            />
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div className="flex gap-2">
                                        <h2>Regularization:</h2>
                                    </div>
                                    <div>
                                        {employee_data?.regularization_date ? employee_data.regularization_date : 'Not specified'}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default EmployeeData;